// import axios from 'axios';
import Vue from 'vue'
import {ebus} from '../vendor/ebus';
import * as firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/messaging';
// import 'firebase/analytics';
// import 'firebase/firestore';
// import firebase from 'firebase';
import firebaseui from './ui-web-4.5.0-dist/npm__de';
import {notificationUtil} from '../notifications/notificationUtil'

// import firebaseui from 'firebaseui-4.1.0-dist/npm__de';
// import * as firebaseui from 'firebaseui'

//trigger async signin when firebase login failed
// let triggerUserUpsert = false;

// var configDev = {
//   apiKey: "AIzaSyBrmxfXQ5WAp9f1cX_qirVoutcQnZTkpwM",
//   authDomain: "shoptest-f25e3.firebaseapp.com",
//   databaseURL: "https://shoptest-f25e3.firebaseio.com",
//   projectId: "shoptest-f25e3",
//   // storageBucket: "shoptest-f25e3.appspot.com",
//   messagingSenderId: "571925636489",
//   appId: "1:571925636489:web:a7bc20998383c26b512d58",
//   measurementId: "G-GKEKLT9M56"
// };
const configProd = {
    apiKey: "AIzaSyCPg4QfhuN_d1zT5arlXWvcNdEaI3rzY5E",
    authDomain: "shop-72a89.firebaseapp.com",
    databaseURL: "https://shop-72a89.firebaseio.com",
    projectId: "shop-72a89",
    storageBucket: "shop-72a89.appspot.com",
    messagingSenderId: "569162158696",
    appId: "1:569162158696:web:7ee9f7ed895066fa64e1dd",
    measurementId: "G-XP5Q40S62W"
};
//DEV shoptest
// const vapidKey = 'BD1Rwj3iQ5-5T4FzB3GmiU-UqcW4VH0uBPuEDlFg379juIacQMoMZJpCEeiIv2Mmv6grGGBQWG5APNF-Q0fXfZs';
//PROD SHOP
const vapidKey ='BCdM8u7K3hgFLB5KqO_S3kXtyxlH28TV5Sh09Ay4APyxvC42UYt3ELsXVcue6aDgEvpzcbPyQdRMBvhkV3tUB0I';
// var configProd = {
//     apiKey: "AIzaSyDA-1fr6HEz_4rHJWCRgTZmeIulkYX_TpM",
//     authDomain: "liefermaxx.firebaseapp.com",
//     databaseURL: "https://liefermaxx.firebaseio.com",
//     projectId: "liefermaxx",
//     storageBucket: "liefermaxx.appspot.com",
//     //messagingSenderId: "573389982943",
//     appId: "1:573389982943:web:5f395442e01747c3"
// };
try {
  firebase.initializeApp(configProd);
} catch (e) {
  console.log('Error in init firebase: ' + e.message);
}


/////////////////////////////////////////////
let fanalytics = null;

export async function logPageView(name) {
  if (fanalytics) {
    fanalytics.setCurrentScreen(name);
    fanalytics.logEvent('screen_view');
    // fanalytics.logEvent('page_view', {screen_name: name});
  }
}

export async function setUserId(fuid) {
  if (fanalytics) {
    fanalytics.setUserId(fuid);
  }
}

export function initAnalytics() {
  try {
    console.log('init analytics');
    fanalytics = firebase.analytics();
  } catch (e) {
    console.log('Error initAnalytics ' + e.message);
  }
  // handleHashChange();
  //does not fire:  window.addEventListener("hashchange", handleHashChange);
}

export async function gevent(event, param) {
//     if (!fanalytics) {
//         return;
//     }
//     //@see https://firebase.google.com/docs/analytics/events?platform=web
//     if (param) {
//         fanalytics.logEvent(event, param);
//     } else {
//         fanalytics.logEvent(event);
//     }
// // .logEvent('goal_completion', { name: 'lever_puzzle'});
}

export function getGitemFromCartItem(itm) {
  let isCoupon = 'nameToDisplay' in itm;
  if (isCoupon) {
    return null;
  }
  let item = {
    item_id: itm.id,
    item_name: itm.nameToDisplay,
    price: itm.itemTotal,
    quantity: itm.count,
    item_variant: itm.vol,
  };
  let extrasToDisplay = itm.extrasToDisplay;
  if (extrasToDisplay.length > 0) {
    item.item_variant += ' ' + extrasToDisplay.join(', ');
  }
  return item;
}

export function getGitemsFromCart(cartItems) {
  let items = [];
  for (let itm of cartItems) {
    let item = getGitemFromCartItem(itm);
    if (item) {
      items.push(item);
    }
  }
  return items;
}

/////////////////////////////////////////////
let messaging = null;
// let supportsPush = false;
let pushToken = null;

export function hasMessaging() {
  return !!messaging;
}

export function getPushToken() {
  let lsPushToken = Vue.ls.get('pushToken');
  console.log('push: getPushToken! ' + lsPushToken);
  return lsPushToken;

  // this.requestPushToken(true, ()=>{
  // });
}

function setPushToken(token) {
  console.log('push: setPushToken! ' + token);
  pushToken = token;
  Vue.ls.set('pushToken', token);
  ebus.$emit('sendPushToken2Server');
}

// export function getSupportsPush() {
//     return supportsPush;
// }

function clearToken() {
  pushToken = null;
  Vue.ls.remove('pushToken');
}

let swRegistration = null;

export function initMessaging(_swRegistration) {
  try {

    swRegistration = _swRegistration;

    if (!messaging) {
      messaging = firebase.messaging();
    }

    console.log('push: messaging initialized');

    // setTimeout(() => {
    //     ebus.$emit('messagingReady');
    // }, 10 * 1000);//wait for onTokenRefresh to execute first
  } catch (e) {
    console.log('push: Error init messaging: ' + e.message);
    messaging = null;
    return;
  }

  try {
    // if (supportsPush) {
    //     return;
    // }
    console.log('push: firebase useServiceWorker = ' + swRegistration);
    messaging.useServiceWorker(swRegistration);
    // Add the public key generated from the console here.
    messaging.usePublicVapidKey(vapidKey);

    // supportsPush = true;

// Callback fired if Instance ID token is updated.
    messaging.onTokenRefresh(() => {
      console.log('push:  onTokenRefresh...');
      // messaging.getToken({vapidKey: vapidKey})
      messaging.getToken({
        vapidKey: vapidKey,
        // serviceWorkerRegistration: swRegistration
      })
        .then((refreshedToken) => {
          console.log('push: refreshed pushToken = ' + currentToken);
          setPushToken(refreshedToken);
          // setTimeout(() => {
          //     ebus.$emit('pushTokenRefreshed');
          // }, 4000);//wait for the server to store the pushToken

          // Indicate that the new Instance ID token has not yet been sent to the
          // app server.
          // Send Instance ID token to app server.
          // sendTokenToServer(refreshedToken);
          // ...
        }).catch((err) => {
        console.log('push: Unable to retrieve refreshed token ', err);
        // showToken('Unable to retrieve refreshed token ', err);
      });
    });

    // Handle incoming messages. Called when:
// - a message is received while the app has focus
// - the user clicks on an app notification created by a service worker
//   `messaging.setBackgroundMessageHandler` handler.
    messaging.onMessage((payload) => {
      console.log('push: Push Message received');

      /*
      fcmOptions:
           link: "https://test39.qsignal.eu/#/orderDetail/T-Q4884-7037"
       from: "787623169582"
       notification:
           badge: "https://theurer.s3.eu-central-1.amazonaws.com/badge.png"
           body: "Testnachricht 1234"
           icon: "https://theurer.s3.eu-central-1.amazonaws.com/icon.png"
           image: "https://theurer.s3.eu-central-1.amazonaws.com/logo-1024-2-1.png"
           silent: false
           tag: "20200522-Beitrag 22-1"
           title: "Beitrag 22-1"
           vibrate: (3) [300, 100, 400]
       priority: "normal"
       */


      let t = 'Benachrichtung erhalten';
      let txt = 'Benachrichtung erhalten';
      let img = '';
      let tag = '';
      let notf = payload.notification;
      // let tag = t;
      //new API using service worker
      //@see https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration/showNotification
      let icon = '';//https://theurer.s3.eu-central-1.amazonaws.com/icon.png';
      if (notf) {
        t = notf.title;
        txt = notf.body;
        if (notf.image) {
          img = notf.image;
        }
        if (notf.tag) {
          tag = notf.tag;
        }
        if (notf.icon) {
          icon = notf.icon;
        }
      }

      //show notification
      notificationUtil.pojsNotification(t, txt, img, icon);

      //show in app notification
      ebus.$emit('showInfo', {
        title: t,
        text: txt,
        image: img,
        // next: next
      });
      ebus.$emit('inAppNotify');//trigger a sound
      console.log('push: inAppNotify has been triggered for ' + txt);

      // let appBase = 'https://vtest39.qsignal.eu/';
      // //FIXME for production
      // // let appBase = 'https://theurer.app/';
      // let link = appBase;
      // if (payload.fcmOptions && payload.fcmOptions.link) {
      //     link = payload.fcmOptions.link;
      // }
      // console.log('push: push message link in util: ' + link);
      // let next = '';
      // // let action = null;
      // // let actionTitle = null;
      // if (link.indexOf('Bestellung') !== -1) {
      //     console.log('push: trigger push notifcation for orderDetail...');
      //     // let orderId = link.substring(link.indexOf('orderDetail') + 11, link.length);
      //     // console.log('push message orderId: ' + orderId);
      //     // next = 'orderDetail' + orderId;
      //
      //
      //
      //     try {
      //         new Notification(
      //             title,
      //             {
      //                 'body': txt,
      //                 'tag': 'push' + Date.now(),
      //             }
      //         );
      //         console.log('push: pojs notification has been triggered for ' + txt);
      //     } catch (e) {
      //         console.log('Error in sn1: ' + e.message);
      //     }
      //
      //
      //     try {
      //         //new API using service worker
      //         //@see https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration/showNotification
      //         let icon = '';//https://theurer.s3.eu-central-1.amazonaws.com/icon.png';
      //         if (notf.icon) {
      //             icon = notf.icon;
      //         }
      //         let badge = '';//'https://theurer.s3.eu-central-1.amazonaws.com/badge.png';
      //         if (notf.badge) {
      //             badge = notf.badge;
      //         }
      //         let nOptions = {
      //             body: txt,
      //             // requireInteraction: false,
      //             tag: tag,
      //             badge: badge,
      //             icon: icon,
      //             image: img,
      //             silent: false,
      //             actions: [
      //                 {
      //                     action: 'open-order-action',
      //                     title: 'Bestellung öffnen',
      //                     icon: 'https://skapps.s3.eu-central-1.amazonaws.com/icons/orderIcon.png'
      //             //                 }
      //             ],
      //             data: {
      //                 link: link
      //             }
      //             // icon: '/static/images/logo.png'
      //         };
      //         // if (actionTitle) {
      //         //     nOptions.actions = [];
      //         //     nOptions.actions.push({
      //         //         action: action,
      //         //         title: actionTitle,
      //         //         icon: 'https://theurer.s3.eu-central-1.amazonaws.com/orderIcon.png'
      //         //     });
      //         // }
      //         console.log('push: trigger showNotification with options: ' + JSON.stringify(nOptions));
      //         navigator.serviceWorker.ready.then(function (registration) {
      //             registration.showNotification(t, nOptions);
      //             console.log('push: registration notification has been triggered for ' + txt);
      //         });
      //     } catch (e) {
      //         console.log('push: Error in show notification util: ' + e.message);
      //     }
      //
      //     // action = 'open-order-action';
      //     // actionTitle = 'Bestellung ansehen';
      // } else {
      //     ebus.$emit('showInfo', {
      //         title: t,
      //         text: txt,
      //         image: img,
      //         next: next
      //     });
      //     ebus.$emit('inAppNotify');//trigger a sound
      //     console.log('push: inAppNotify has been triggered for ' + txt);
      // }


      //show notification
      // try {
      //     // new Notication() is deprecated //@see https://jameshfisher.com/2017/09/12/notification-api-deprecated/
      //     // let nOptions = {
      //     //     body: txt,
      //     //     tag: tag,
      //     //     badge: 'https://theurer.s3.eu-central-1.amazonaws.com/badge.png',
      //     //     icon: 'https://theurer.s3.eu-central-1.amazonaws.com/icon.png'
      //     // };
      //     // let notification = new Notification(t, nOptions);
      //     // notificationUtil.onclick = function (event) {
      //     //     console.log('push notification clicked in util. open link ' + link);
      //     //     event.preventDefault(); // prevent the browser from focusing the Notification's tab
      //     //     window.open(link, '_blank');
      //     // }
      //
      //
      //     //new API using service worker
      //     //@see https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration/showNotification
      //     let nOptions = {
      //         body: txt,
      //         // requireInteraction: false,
      //         tag: tag,
      //         badge: 'https://theurer.s3.eu-central-1.amazonaws.com/badge.png',
      //         icon: 'https://theurer.s3.eu-central-1.amazonaws.com/icon.png',
      //         data:{
      //             link: link
      //         }
      //         // icon: '/static/images/logo.png'
      //     };
      //     if (actionTitle) {
      //         nOptions.actions = [];
      //         nOptions.actions.push({
      //             action: action,
      //             title: actionTitle,
      //             icon: 'https://theurer.s3.eu-central-1.amazonaws.com/orderIcon.png'
      //         });
      //     }
      //     console.log('trigger showNotification with options: ' + JSON.stringify(nOptions));
      //     navigator.serviceWorker.ready.then(function (registration) {
      //         registration.showNotification(t, nOptions);
      //     });
      // } catch (e) {
      //     console.log('Error in show notification util: ' + e.message);
      // }
    }); //eof onMessage

    console.log('push: Push Messaging is supported');


    setTimeout(() => {
      getPushToken();
    }, 3000);//wait for onTokenRefresh to execute first


  } catch (e) {
    // supportsPush = false;
    clearToken();
    console.log('push: catched messaging exception: ' + e.message);
  }
}

// initMessaging();


export function requestPushToken(silent) {
  console.log('push: requestPushToken silent=' + silent);
  if (!messaging) {
    // if(!supportsPush){
    //     ebus.$emit('showInfo', {
    //         title: 'Leider sind Benachrichtigungen in d für diese Seite blockiert',
    //         text: 'Wenn du in knapp einer Stunde nochmal diese Seite öffnest, dann wird deine Blockade aufgehoben. ' +
    //             'Ansonsten musst du die Webseiteneinstellungen für diese Seite ändern.'
    //     });
    // }
    console.log('push: messaging is not available');
    clearToken();
    return;
  }
  console.log('push: messaging is available');
  // Get Instance ID token. Initially this makes a network call, once retrieved
// subsequent calls to getToken will return from cache.
  //If notification permission isn't already granted, getToken() asks the user for permission.
  // The returned promise rejects if the user does not allow the app to show notifications.
  messaging.getToken({
    vapidKey: vapidKey,
    // serviceWorkerRegistration: swRegistration
  }).then((currentToken) => {
    if (currentToken) {
      setPushToken(currentToken);
      console.log('push: Has Push Permission');
      console.log('push: pushToken = ' + currentToken);
      // sendTokenToServer(currentToken);
      // updateUIForPushEnabled(currentToken);
    } else {
      // Show permission request.
      console.log('push: No Instance ID token available. Request permission to generate one.');
      // Show permission UI.
      // updateUIForPushPermissionRequired();
      clearToken();
      if (!silent) {
        reqPushPerm();
      }
    }
    // if(cb){
    //     cb();
    // }
  }).catch((err) => {
    console.log('push: An error occurred while retrieving pushToken: ' + err);
    // showToken('Error retrieving Instance ID token. ', err);
    if (('' + err).indexOf('Expected OAuth') > 0) {
      //retry
      setTimeout(() => {
        console.log('push: retry requestPushToken...');
        requestPushToken(silent);
      }, 2222);
    } else if (('' + err).indexOf('not granted') > 0) {
      // Messaging: The notification permission was not granted and blocked instead
      //retry
      setTimeout(() => {
        clearToken();
        if (!silent) {
          console.log('push: force reqPushPerm...');
          reqPushPerm();
        } else {
          console.log('push: permission was not granted');
        }
      }, 1111);
    } else {
      clearToken();
      if (!silent) {
        reqPushPerm();
      }
    }

    // if(cb){
    //     cb();
    // }
  });
}

function reqPushPerm(isKiosk) {
  console.log('Manually request permission...');
  Notification.requestPermission().then(function (permission) {
    // If the user accepts, let's create a notification
    console.log('push: Permission result === ' + permission);
    if (permission === "granted") {
      requestPushToken(true);
    } else {
      clearToken();
      if(!isKiosk) {
//TODO
      }
      // ebus.$emit('showInfo', {
      //   title: 'Leider hast du Benachrichtigungen vor kurzem blockiert',
      //   text: 'Du kannst die Benachrichtigungen in deinen Browser-Einstellungen zulassen ' +
      //     'oder du öffnest die Seite einfach in einer Stunde nochmal.'
      // });
    }
  });
}

/////////////////////////////////////////////////////


// firebase.auth().useDeviceLanguage();
let fauth = firebase.auth();
fauth.languageCode = 'de'; //BCP-47 https://firebase.google.com/docs/reference/js/firebase.auth.Auth.html#language-code

// Retrieve Firebase Messaging object.
// const messaging = firebase.messaging();

// firebase.auth().languageCode = 'de'; //BCP-47 https://firebase.google.com/docs/reference/js/firebase.auth.Auth.html#language-code
fauth.onAuthStateChanged(function (user) {
  if (user) {
    // triggerUserUpsert = true;
    // ebus.$emit('triggerUserUpsert');
    console.log('???? firebase user is signed in ', user);
    ebus.$emit('userSignedIn');
    ebus.$emit('userSignedInRegister');
    console.log('???? firebase userSignedIn and userSignedInRegister emitted');
    // User is signed in.
    // fbasUser = user;
  } else {
    ebus.$emit('userSignedOut');
    console.log('???? firebase user is signed out');

    //trigger auto signin
    // triggerAutoSignin = true;
    // try{
    //   setTimeout(function () {
    //     var scope = getScope();
    //     scope.safeApply(function () {
    //       scope.root.asyncAutoSignIn();
    //     });
    //   }, 10000);
    // }catch (error){
    //   //suck
    //   console.log('???? error triggering async login ',error);
    // }

    // No user is signed in.
    // fbasUser = null;
  }
});

export function auth() {
  return fauth;
}


export function resetEmail(emailAddress, cb) {
  fauth.sendPasswordResetEmail(emailAddress, null)
    .then(() => {
      console.log('sendPasswordResetEmail was ok');
      cb(true);//SMS was sent
    })
    .catch((err) => {
      console.log('eeror in sendPasswordResetEmail');
      cb(false);
      verifySmsCode(null, err);
    });
}

// export function analytics() {
//     return flytics;
// }

// iframe message listener
// window.addEventListener("message", function (e) {
//     //if (event.origin !== "http://example//.com:8080")
//     //return;
//     try {
//         var myIframe = document.getElementById('signinFrame');
//         if (myIframe.src && myIframe.src.indexOf(e.origin) === 0) {
//             try {
//                 var data = JSON.parse(e.data);
//                 console.log('message event raw data = ' + e.data);
//
//                 if (data.event === 'signinReturn') {
//                     ebus.$emit('signinReturn');
//                 }
//             } catch (e) {
//                 alert('Parsing error: ' + e);
//                 console.log('error: ', e);
//             }
//         }
//     } catch (e) {
// //        console.log('Uups parsing rawData error: ' + e);
//     }
// }, false);


export function getUser() {
  try {
    return fauth.currentUser;
  } catch (e) {
    console.log('bugIsAccount error in getUser(): ' + e, e);
  }
  return null;
}

export function getEmail() {
  let u = getUser();
  if (u) {
    return u.email;
  }
  return null;
}

export function getPhone() {
  let u = getUser();
  if (u) {
    return u.phoneNumber;
  }
  return null;
}

export function getFuid() {
  let u = getUser();
  if (u) {
    return u.uid;
  }
  return null;
}


// export function gotoSSOPage() {
//     console.log('??? host??? ' + window.location.host);
//     var ssoUrl = 'https://' + window.location.host + '/signin/getService'; //host = with port
//     var win = window.open(ssoUrl, '_blank');
//     win.focus();
// }

export function isAccount() {
  let fbUser = getUser();
  if (!fbUser) {
    return false;
  }
  try {

    // console.log('bugIsAccount checkfor fbUser.displayName && fbUser.email && fbUser.phoneNumber = ' + fbUser.displayName && fbUser.email && fbUser.phoneNumber);
    // console.log('bugIsAccount checkfor  fbUser.displayName.length > 3 && fbUser.email.length > 2 = ' + fbUser.displayName.length > 3 && fbUser.email.length > 2);
    // console.log('bugIsAccount checkfor (/.+@.+[.].+/.test(fbUser.email) === true) = ' + (/.+@.+[.].+/.test(fbUser.email) === true));
    // console.log('bugIsAccount checkfor  fbUser.phoneNumber.length > 6 && fbUser.phoneNumber !== null = ' + fbUser.phoneNumber.length > 6 && fbUser.phoneNumber !== 'null');

    return !!(
      fbUser.displayName && fbUser.email && fbUser.phoneNumber
      && fbUser.displayName.length > 3 && fbUser.email.length > 2
      && (/.+@.+[.].+/.test(fbUser.email) === true)
      && fbUser.phoneNumber.length > 6 && fbUser.phoneNumber !== 'null');
  } catch (e) {
    console.log('bugIsAccount error in isAccount: ', e);
  }
  return false;
}

export function updateName(name, cb) {
  var currentUser = getUser();
  if (currentUser) {
    currentUser.updateProfile({displayName: name}).then(() => {
      cb(true);
    }).catch((error) => {
      console.log('bugIsAccount error in updateName: ' + error, error);
      cb(false);
    });
  }
}

export function updateUserEmail(email, cb) {
  var currentUser = getUser();
  if (currentUser) {
    //see https://stackoverflow.com/questions/42752702/passing-email-address-in-custom-token
    currentUser.updateEmail(email).then(() => {
      console.log('??? updateEmail in firebase successfully');
      cb({ok: true});
    }).catch((error) => {
      console.log('bugIsAccount error in updateEmail: ' + error, error);
      cb({ok: false, error});
      //   // Handle Errors here.
      // var errorCode = error.code;
      // var errorMessage = error.message;
      // console.log('??? error updating email: ', error);
    });
  }
}

export function logout(cb) {
  fauth.signOut()
    .then(function () {
      // console.log('??? Sign-out successful.');
      cb(true);
    })
    .catch(function (error) {
      // An error happened
      cb(false);
    });
}

// export function getTriggerUserUpsert() {
//     return triggerUserUpsert;
// }
//
// export function setTriggerUserUpsert(flag) {
//     triggerUserUpsert = flag;
// }


////////////////////////////////////////////////////////////
//Firebase UI
let ui = null;

let uiConfig = {
  callbacks: {
    signInSuccessWithAuthResult: function (authResult, redirectUrl) {
      console.log("signInSuccessWithAuthResult(): authResult =", authResult, ", redirectUrl =", redirectUrl);
      // console.log('??? signInSuccessWithAuthResult redirectUrl = ' + redirectUrl);
      // User successfully signed in.
      // Return type determines whether we continue the redirect automatically
      // or whether we leave that to developer to handle.
      setTimeout(() => {
        ebus.$emit('signinReturn');
      }, 200);
      return false; //new automatic redirect
    },
    signInFailure: function (error) {
      //SignInFailure callback is for merge conflict
      console.error("signInFailure(): error =", error);
    },
    uiShown: function () {
      // The widget is rendered.
      // Hide the loader.
      // TODO document.getElementById('loader').style.display = 'none';
    },
  },

  // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
  // signInFlow: 'popup',
  // signInSuccessUrl: '<url-to-redirect-to-on-success>',
  //@see https://github.com/firebase/firebaseui-web/tree/v3.6.0#configuration
  signInOptions: [
    {
      buttonColor: '#2F2F2F',
      provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
      requireDisplayName: false,
    },

    // {
    //     provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
    //     scopes: [
    //         // 'first_name',
    //         // 'last_name',
    //         'public_profile',
    //         'email'
    //         // 'user_likes',
    //         //'user_friends'
    //     ]
    //     // ,
    //     // customParameters: {
    //     //   // Forces password re-entry.
    //     //   auth_type: 'reauthenticate'
    //     // }
    // },


    //defaultCountry and whitelistedCountries only work for firebase.auth.PhoneAuthProvider. Please check the documentation.
    {
      buttonColor: '#2F2F2F',
      provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
      defaultCountry: 'DE',
      whitelistedCountries: ['AT', '+43', 'DE', '+49', 'CH', '+41']
    }
    // ,
    // {
    //   provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
    //   // recaptchaParameters: {
    //   //   type: 'image', // 'audio'
    //   //   size: 'normal', // 'invisible' or 'compact'
    //   //   badge: 'bottomleft' //' bottomright' or 'inline' applies to invisible.
    //   // },
    //   defaultCountry: selectedLang.substr(0, 2).toUpperCase()// 'DE', // Set default country to the United Kingdom (+44).
    //
    //   // For prefilling the national number, set defaultNationNumber.
    //   // This will only be observed if only phone Auth provider is used since
    //   // for multiple providers, the NASCAR screen will always render first
    //   // with a 'sign in with phone number' button.
    //   // defaultNationalNumber: '1234567890',
    //
    //   // You can also pass the full phone number string instead of the
    //   // 'defaultCountry' and 'defaultNationalNumber'. However, in this case,
    //   // the first country ID that matches the country code will be used to
    //   // populate the country selector. So for countries that share the same
    //   // country code, the selected country may not be the expected one.
    //   // In that case, pass the 'defaultCountry' instead to ensure the exact
    //   // country is selected. The 'defaultCountry' and 'defaultNationaNumber'
    //   // will always have higher priority than 'loginHint' which will be ignored
    //   // in their favor. In this case, the default country will be 'GB' even
    //   // though 'loginHint' specified the country code as '+1'.
    //   // loginHint: '+11234567890'
    // }


    // ,
    // List of OAuth providers supported.
    // firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
    // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
    // firebase.auth.GithubAuthProvider.PROVIDER_ID
  ],
  // Terms of service url.
  tosUrl: 'https://static.qsignal.eu/legal/agb.html',
  // Privacy policy url.
  privacyPolicyUrl: 'https://static.qsignal.eu/legal/datenschutz.html'
};

export function initFirebaseUi() {
  // Initialize the FirebaseUI Widget using Firebase.
  try {
    if (!ui) {
      console.log('Create new firebaseUI');
      ui = new firebaseui.auth.AuthUI(fauth);
    } else {
      console.log('firebaseUI already exists');
    }

    if (ui) {

      //disable accountchooser
      //Default: firebaseui.auth.CredentialHelper.ACCOUNT_CHOOSER_COM
      //@see https://github.com/firebase/firebaseui-web#credential-helper
      // if (isInsideAndroid || window.isoe) {
      uiConfig.credentialHelper = firebaseui.auth.CredentialHelper.NONE;
      console.log('firebase accountchooser deactivated');
      // }

      if (ui.isPendingRedirect()) {
        ui.start('#firebaseui-auth-container', uiConfig);
      } else {
        ui.reset();
        // The start method will wait until the DOM is loaded.
        ui.start('#firebaseui-auth-container', uiConfig);
      }
      console.log('Firebase UI mounted!!!!')
    } else {
      console.log('Firebase UI missing!!!!')
    }

  } catch (e) {
    //instance might already exist
    console.log('firebase error in initFirebaseUi: ' + e.message);
  }
}

export function initRecaptcha(solved) {
  console.log('??? initRecaptcha');
  try {
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('captchaContainer', {
      'size': 'invisible',
      'callback': function (response) {
        // reCAPTCHA solved, allow verifyPhoneNumber.
        console.log('??? recaptchaVerifier solved!!!!');
        solved();
      }
    });
  } catch (e) {
    console.log('error in initRecaptcha: ' + e.message);
  }

}

//@see https://stackoverflow.com/questions/45304912/firebase-users-setting-phone-number
//@see https://firebase.google.com/docs/reference/js/firebase.auth.PhoneAuthProvider.html
let verificationId = '';
let smsCounter = 0;

export function updatePhone(phoneCredential) {
  return new Promise((resolve, reject) => {
    //https://firebase.google.com/docs/reference/js/v8/firebase.User#updatephonenumber
    let user = getUser();
    user.updatePhoneNumber(phoneCredential).then((updatedUser) => {
      resolve(updatedUser);
    }, (err) => {
      reject(err);
    });
  });
}

export function sendSms(phoneNumber, cb) {
  let provider = new firebase.auth.PhoneAuthProvider();
  //prevent endless SMS messages
  smsCounter++;
  if (smsCounter > 6) {
    cb(false);
    return;
  }
  provider.verifyPhoneNumber(phoneNumber, window.recaptchaVerifier)
    .then(function (_verificationId) {
      verificationId = _verificationId;
      console.log('??? verificationId = ' + verificationId);
      cb(true);//SMS was sent
    })
    .catch((err) => {
      console.log('Error in sendSms: ' + err);
      cb(false);
    });
}

export function verifySmsCode(smsCode) {
  return firebase.auth.PhoneAuthProvider.credential(verificationId, smsCode);
}

// function subscribeToTopic(regToken, topic){
//     // https://iid.googleapis.com/iid/v1/'+regToken+'/rel/topics/'+topic+'
//     let msg ={
//
//     };
//
//     axios.post('https://iid.googleapis.com/iid/v1/'+regToken+'/rel/topics/'+topic, msg, {
//         headers: {'Content-Type': 'application/json'}, timeout: (12*1000)
//     })
//         .then(reply => {
//             // console.log('<<< Reply ', reply);
//             // console.log('<<< Reply :' + JSON.stringify(reply));
//             if (reply && reply.data) {
//
//             } else {
//             }
//         }).catch(err => {
//     });
// }

//https://firebase.google.com/docs/cloud-messaging/js/client
// export function requestPushPermission(){
//     Notification.requestPermission().then((permission) => {
//         if (permission === 'granted') {
//             console.log('Notification permission granted.');
//             // TODO(developer): Retrieve an Instance ID token for use with FCM.
//             // ...
//         } else {
//             console.log('Unable to get permission to notify.');
//         }
//     });
// }
